export default "__VITE_ASSET__DF6SmLOH__"